// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"926":"703c0dab","4173":"7d230d3d"}[chunkId] + ".chunk.css";
};